export default "__VITE_ASSET__CohT2V9z__"